import { createContext, useContext } from "react";

import type { Employee } from "~/providers/employee-provider";

interface EmployeeContext {
  employees: Employee[];
}

export const EmployeeContext = createContext<EmployeeContext | undefined>(
  undefined,
);

export const useEmployee = () => {
  const context = useContext(EmployeeContext);
  if (context === undefined) {
    throw new Error("useEmployee must be used within a EmployeeProvider");
  }

  return context;
};
